import { RequestExecutorError } from "./request-executor-error";
import { z } from "zod";
const ResponseWrapper = z.object({
    result: z.record(z.any()),
});
export class RequestExecutor {
    constructor(testServerConfig) {
        this.testServerConfig = testServerConfig;
    }
    async json(path, schema, requestInit = {}) {
        var _a;
        // Headers
        const defaultHeaders = {
            Accept: "application/json",
        };
        if (requestInit.body)
            defaultHeaders["Content-Type"] = "application/json";
        if (this.testServerConfig.accessToken) {
            defaultHeaders["Authorization"] =
                `Bearer ${this.testServerConfig.accessToken}`;
        }
        // API secret allows for more priviledged access from secure environments (e.g. other servers)
        if (this.testServerConfig.apiSecret) {
            defaultHeaders["x-sn-api-secret"] = this.testServerConfig.apiSecret;
        }
        // Body
        let body;
        if (requestInit.body && typeof requestInit.body === "object")
            body = JSON.stringify(requestInit.body);
        const fullUrl = this.fullUrl(path, requestInit.query);
        const response = await fetch(fullUrl, {
            ...requestInit,
            headers: {
                ...requestInit.headers,
                ...defaultHeaders,
            },
            body: body,
        });
        const endpoint = `${(_a = requestInit.method) !== null && _a !== void 0 ? _a : "GET"} ${path}`;
        if (!response.ok) {
            const bodyString = await response.text();
            throw RequestExecutorError.serverError(endpoint, response.status, bodyString);
        }
        const json = await response.json();
        const wrapperParseResult = ResponseWrapper.safeParse(json);
        if (!wrapperParseResult.success) {
            console.error(`Response was:`);
            console.error(json);
            throw RequestExecutorError.responseParsingError(endpoint, wrapperParseResult.error);
        }
        const responseParseResult = schema.safeParse(wrapperParseResult.data.result);
        if (!responseParseResult.success) {
            console.error(`Response was:`);
            console.error(wrapperParseResult.data.result);
            throw RequestExecutorError.responseParsingError(endpoint, responseParseResult.error);
        }
        return responseParseResult.data;
    }
    fullUrl(path, query) {
        let url = `${this.testServerConfig.baseUrl}/api/v2${path}`;
        const queryString = query === null || query === void 0 ? void 0 : query.toString();
        if (queryString)
            url += `?${queryString}`;
        return url;
    }
}
